import { useState } from 'react';
import logo from '../media/Balanz_white_logo.svg';
import { Link, useLocation, useNavigate} from 'react-router-dom';
import validate from '../utils/validateLogin';
import axios from 'axios';
import { useGlobalContent } from '../context/helpersProvider';

import RememberIco from '../media/ckeckbox-white.svg';
import EyeIconOpen from '../media/blue-eye-icon-open.svg';
import EyeIconClose from '../media/blue-eye-icon-close.svg';
import { saveToken } from '../utils/authCrypto';

type Step = 1 | 2

export const LoginUsuario = () => {
  const history = useNavigate()
  const location = useLocation()

  interface Data {
    password: string
    email: string
  }
  interface matchtipes {
    status: boolean
    message: string
  }
  const [step, setStep] = useState<Step>(1)
  const [nonce, setNonce] = useState<string>('')

  const [Match, setMatch] = useState<matchtipes>({
    status: true,
    message: '',
  })
  const [errors, setErrors] = useState<Data>({
    password: '',
    email: '',
  })
  const [Datos, setDatos] = useState<Data>({
    password: '',
    email: '',
  })

  const [keepMeLoggedIn, setKeepMeLoggedIn] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const publish_report = process.env.REACT_APP_SECRET_KEY;

  const { setShowLoading, setShowToast } = useGlobalContent()

  const handleKeepMeLoggedInChange = () => setKeepMeLoggedIn((prev) => !prev)
  const togglePasswordVisibility = () => setShowPassword((prev) => !prev)

  function handleError(e: any) {
    if (e.target.value.length < 1) {
      return
    } else {
      setErrors(
        validate({
          ...Datos,
          [e.target.name]: e.target.value,
        })
      )
    }
  }

  function handleInputChange(e: any) {
    setDatos({
      ...Datos,
      [e.target.name]: e.target.value,
    })
  }
  const handleChange = (e: any) => {
    const { name, value } = e.target
    setDatos({ ...Datos, [name]: value })
  }

  const isValidEmail = (email: string) => /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/.test(email.trim())

  const initLogin = async (e: any) => {
    e.preventDefault()
    setMatch({ status: false, message: '' })

    if (Datos.email.trim() === '') {
      setShowToast({ open: 'true', type: 'error', message: 'Please enter your email' })
      return
    }
    if (!isValidEmail(Datos.email)) {
      setShowToast({ open: 'true', type: 'error', message: 'Email is invalid' })
      return
    }

    try {
      setShowLoading('true')
      const resp = await axios.post('/auth/init', { email: Datos.email.trim() })

      const data = resp?.data?.data

      if (data?.tipoAutenticacion === 3 && data?.URLAuth) {
        setShowLoading('false')
        window.location.href = data.URLAuth
        return
      }

      const nonceFromApi = data?.nonce
      
      if (!nonceFromApi) throw new Error('Nonce not received')

      setNonce(nonceFromApi)
      setStep(2)
      setShowLoading('false')
    } catch (err: any) {
      setShowLoading('false')
      const msg = err?.response?.data?.message || err?.message || 'Init login failed'
      setMatch({ status: false, message: msg })
      setShowToast({ open: 'true', type: 'error', message: msg })
    }
  }

  const finishLogin = async (e: any) => {
  e.preventDefault()
  setMatch({ status: false, message: '' })

  if (Datos.email.trim() === '' || Datos.password.trim() === '') {
    setShowToast({ open: 'true', type: 'error', message: 'Please fill all fields' })
    return
  }

  if (!nonce) {
    setShowToast({
      open: 'true',
      type: 'error',
      message: 'Session expired. Please re-enter your email.',
    })
    setStep(1)
    return
  }

  try {
    setShowLoading('true')

    const resp = await axios.post('/auth/login', {
      email: Datos.email.trim(),
      nonce,
      pass: Datos.password,
      keepMeLoggedIn,
    }, { skipAuthRedirect: true }
    )

    const token = resp?.data?.data?.accessToken
    const user = resp?.data?.data?.user

    if (!token || !user) throw new Error('Login response incomplete')

    saveToken(token)
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    localStorage.setItem('idClient', String(user.id))
    localStorage.setItem('emailClient', user.email)
    localStorage.setItem('nameClient', user.name)

    localStorage.removeItem('id')
    localStorage.removeItem('email')
    localStorage.removeItem('name')

    setShowLoading('false')

    if (location.state) history(`/publish/${location.state}`)
    else history('/home')

  } catch (err: any) {
    setShowLoading('false')
    const msg =
      err?.response?.data?.message ||
      err?.message ||
      'Login failed'

    setMatch({ status: false, message: msg })
    setShowToast({ open: 'true', type: 'error', message: msg })
  }
}


  const goBackToEmail = () => {
    setStep(1)
    setNonce('')
    setDatos((prev) => ({ ...prev, password: '' }))
  }


  return (
    <div className='columns w-row container-log'>
      <div className='logocolumn w-col w-col-4 w-col-stack'>
        <img src={logo} loading='lazy' width='600' alt='Balanz logo' className='loginlogo' />
      </div>
      <div className='formcolumn w-col w-col-8 w-col-stack'>
        <div className='form w-form'>
          <form id='wf-form-Email' name='wf-form-Email' data-name='Email' method='get'>
            {/* <h2 className='h2-titles center'>Login</h2> */}
            <label htmlFor='Email' className='field-label'>
              Corporate E-mail
            </label>
            <input
              type='email'
              autoFocus
              className='text-field email w-input'
              name='email'
              data-name='Email'
              placeholder='Corporate E-mail'
              onChange={handleInputChange}
              onBlur={handleError}
              value={Datos.email}
              autoComplete={'off'}
              disabled={step === 2}
              style={step === 2 ? { opacity: 0.7, cursor: 'not-allowed' } : undefined}
            />
            {errors.email && <p className='alert'>{errors.email}</p>}

            {step === 2 && (
              <div style={{ marginTop: '8px' }}>
                <button type='button' onClick={goBackToEmail} className='button w-button change-email-btn' style={{ width: 'auto' }}>
                  Change email
                </button>
              </div>
            )}

            {step === 2 && (
              <div style={{ position: 'relative' }}>
                <label htmlFor='Password' className='field-label'>
                  Password
                </label>

                <input
                  type={showPassword ? 'text' : 'password'}
                  className='text-field pass w-input'
                  autoComplete={'current-password'}
                  name='password'
                  placeholder='Your password'
                  onChange={handleChange}
                  value={Datos.password}
                />
              <img
                  src={showPassword ? EyeIconOpen : EyeIconClose}
                  alt='Toggle visibility'
                  onClick={togglePasswordVisibility}
                  style={{
                    position: 'absolute',
                    right: '16px',
                    top: '50%',
                    transform: 'translateY(0%)',
                    cursor: 'pointer',
                    width: '24px',
                    height: '24px',
                  }}
                />

                {errors.password && <p className='alert'>{errors.password}</p>}
              </div>
            )}

            <div className='text-block'>
              <Link to='/forgot'>
                <span className='linktext'>Forgot Password?</span>
              </Link>
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: '8px' }}>
                <input type='checkbox' checked={keepMeLoggedIn} style={{ display: 'none' }} onChange={handleKeepMeLoggedInChange} />
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '20px',
                    height: '20px',
                    backgroundColor: keepMeLoggedIn ? '#151f6d' : '#fff',
                    border: '2px solid #151f6d',
                  }}
                >
                  {keepMeLoggedIn && <img src={RememberIco} alt='Checked Icon' />}
                </span>
                <span>¿Keep me logged in?</span>
              </label>
            </div>

            <p className='alert'>{Match.message}</p>

            {step === 1 ? (
              <button onClick={initLogin} className='button continue w-button'>
                Continue
              </button>
            ) : (
              <button onClick={finishLogin} className='button continue w-button'>
                Login
              </button>
            )}

            <div className='text-block new-user'>
              New user?
              <Link className='linktext' to='/create'>
                <span className='linktext'>{' Create your account'}</span>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
